import { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import IsLoadingBar from '../isLoading';
import Auth from '../../Auth/Auth';
const auth = new Auth();

const SalesforceFilter = ({ filters, filterName, filterType, setSelectedTypeFilter, isLoading }) => {

    const setSelectedFilter = () => {
        if (filterType === 'Category' || filterType === 'Severity' || filterType === 'Status') {
            return;
        }

        setSelectedTypeFilter();
    };

    return (
        <div className='filter-col'>
            <div className='salesforce-filter-box'>
                <p className='advanced-filter-header'>{filterName}</p>
                {isLoading ?
                    <IsLoadingBar />
                    :
                    <Form>
                        {filters.map((item, index) =>
                            <Form.Check
                                key={index}
                                custom
                                label={item}
                                type={'checkbox'}
                                area={filterType}
                                onChange={() => setSelectedFilter()}
                                value={item}
                                id={`${item}-${index}`}
                            />
                        )}
                    </Form>
                }
            </div>
        </div>
    );
};

export default function SalesforceFilters(props) {
    const [showSalesforceFilters, setShowSalesforceFilters] = useState(false);
    const [salesforceFiltersLoading, setSalesforceFiltersLoading] = useState(true);
    const [salesforceFilters, setSalesforceFilters] = useState([]);

    const [selectedFilters, setSelectedFilters] = useState([]);
    const [selectedTypes,setSelectedTypes] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    
    useEffect(() => {
        getSalesforceFilterColumns();
    }, []);

    useEffect(() => {        
        setSelectedFilters([]);
        //Show all filters - the below call will re-render the filter list
        setSelectedTypes(setSelectedTypeFilter('RecordType'));
    }, [props.clearSaleforceFilters]);

    const getSalesforceFilterColumns = async (filterType) => {
        let accessToken = await auth.getToken();
        return fetch('/api/getSalesforceFilter', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            setSalesforceFilters(data);
            setSalesforceFiltersLoading(false);
        }).catch((error) => {
            console.error('Error:', error);
            setSalesforceFiltersLoading(false);
        });
    };

    const setSelectedTypeFilter = (filterType) => {
        const salesforceFilters = document.querySelector('#salesforce-filters');

        if (salesforceFilters !== null && filterType === 'RecordType') {
            //On Record Type change reset the area filters            
            const areaCheckboxes = salesforceFilters.querySelectorAll('input:checked[area="Area"]');
            areaCheckboxes.forEach(filter => {
                filter.checked = false;
            });
        }

        const checkboxes = document.querySelectorAll(`[area="${filterType}"]`);
        let selectedFilters = [];
        
        for (let i = 0; i < checkboxes.length; i++){
            if (checkboxes[i].checked === true) {
                selectedFilters.push(checkboxes[i].value);
            }
        }
        return selectedFilters;
    };

    const setFilterValues = () => {
        const advancedFilterContainer = document.getElementById('salesforce-filters');
        const filterCheckboxes = advancedFilterContainer.querySelectorAll('input:checked');
        let selectedFilterValues = [];
        filterCheckboxes.forEach(filter => {
            const filterName = filter.getAttribute('area');
            const filterValue = filter.getAttribute('value');
            selectedFilterValues.push({ area: filterName, value: filterValue });
        });

        setSelectedFilters(selectedFilterValues);
        setShowSalesforceFilters(false);
    };

    const filterAvailbleOptions = (filters, selectedFilters, filterOnPreviousValue) => {
        if (selectedFilters.length > 0) {
            filters = filters.filter(el => selectedFilters.includes(el[filterOnPreviousValue]));
        }

        return filters;
    };
    
    const optionNames = (filters, filterName) => {
        const distinctList = new Set(filters.map(el => el[filterName]));
        return Array.from(distinctList).sort();
    };

    const clearFilters = () => {
        const advancedFilterContainer = document.getElementById('salesforce-filters');
        const filterCheckboxes = advancedFilterContainer.querySelectorAll('input:checked');
        filterCheckboxes.forEach(filter => {
            filter.checked = false;
        });

        //Show all filters - the below call will re-render the filter list
        setSelectedTypes(setSelectedTypeFilter('RecordType'));
    };

    if (!props.isSalesForce) {
        return <div/>;
    }

    return (
        <div className='salesforce-filter-wrapper'>
            <Button onClick={() => setShowSalesforceFilters(true)} className='mb-3'>Launch advanced filters for Salesforce</Button>
            <div className='mb-5'>
                <p className='mb-0'><strong>Current Selection</strong></p>
                {selectedFilters.map((item, index) => 
                    <div key={index}><strong>{item.area}: </strong>{item.value}</div>
                )}
            </div>


            <div className={showSalesforceFilters ? 'salesforce-modal active' : 'salesforce-modal'}>
                <div className='backdrop'></div>                   
                
                <div id='salesforce-filters'>
                    <div className='text-right'>
                        <Button variant='link' onClick={() => setShowSalesforceFilters(false)}>X</Button>
                    </div>
                    <div className='d-flex salesforce-filter-container'>
                        <SalesforceFilter filters={optionNames(salesforceFilters.RecordType,  'RecordType')} filterName='Record Type' filterType='RecordType' setSelectedTypeFilter={() => setSelectedTypes(setSelectedTypeFilter('RecordType'))} isLoading={salesforceFiltersLoading}  />
                        <SalesforceFilter filters={optionNames(filterAvailbleOptions(salesforceFilters.Area, selectedTypes, 'RecordType'), 'Area')} filterName='Area' filterType='Area' setSelectedTypeFilter={() => setSelectedAreas(setSelectedTypeFilter('Area'))} isLoading={salesforceFiltersLoading} />
                        <SalesforceFilter filters={optionNames(salesforceFilters.Severity,  'Severity')} filterName='Severity' filterType='Severity' isLoading={salesforceFiltersLoading} />
                        <SalesforceFilter filters={optionNames(salesforceFilters.Status,  'Status')} filterName='Status' filterType='Status' isLoading={salesforceFiltersLoading} />
                    </div>
                    <footer className='text-right p-2'>
                        <Button variant='link' onClick={() => clearFilters()} className='clear-filters'>clear filters</Button>
                        <Button onClick={() => setFilterValues()} >Add Salesforce filters</Button>
                    </footer>
                </div>
                
            </div>

        </div>
    );
 
}